/**
 * Generated bundle index. Do not edit.
 */
export { MatSliderModule, MAT_SLIDER_VALUE_ACCESSOR, MatSliderChange, MatSliderBase, _MatSliderMixinBase, MatSlider } from './public-api';
//# sourceMappingURL=index.js.map